/**
 * @file: react-native-compressor.web.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

export const getVideoMetaData = async () => {
  throw new Error('Not supported on web');
};

export const Image = {
  compress: async () => {
    throw new Error('Not supported on web');
  },
};

export const Video = {
  compress: async () => {
    throw new Error('Not supported on web');
  },
};
